// extracted by mini-css-extract-plugin
module.exports = {"navarr":"navBar_navarr__1huPk","logo":"navBar_logo__2zODd","btn":"navBar_btn__1nxHM","contenedorBtn":"navBar_contenedorBtn__2IdvC","link":"navBar_link__3jZpu"};